import { api } from '@/core/api/';

const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const baseApiURL = 'api/providerQuestion';

export const getStaticInformation = async () => {
  return await api.get(`${baseApiURL}/static-information`);
};
export const getQuestions = (providerQuestionSection, providerId) =>
  api.get(`${baseApiURL}/questions/${providerQuestionSection}/${providerId}`);

export const getSections = (providerId, academicYearId) =>
  api.get(`${baseApiURL}/sections/${providerId}/${academicYearId}`);

export const submitAnswer = (payload) =>
  api.post(`${baseApiURL}/submitanswer`, payload);

export const updateStatus = (payload) =>
  api.post(`${baseApiURL}/updatestatus`, payload);

export const submitGeographicArea = (payload) =>
  api.post(`${baseApiURL}/submitGeographicArea`, payload);

export const getMunicipalities = (providerId, academicYearId) =>
  api.get(`${baseApiURL}/municipality/${providerId}/${academicYearId}`);

export const getDisciplineTypeOptions = () =>
  api.get(`${baseApiURL}/disciplinetype`);

export const getOfferedServices = (academicYearId, companyId) =>
  api.get(`${baseApiURL}/services/${academicYearId}/${companyId}`);

export const submitOfferedServices = (payload) =>
  api.post(`${baseApiURL}/submitofferedservices`, payload);

export const submitPublicOfficials = (payload) =>
  api.post(`${baseApiURL}/submitpublicofficials`, payload, header);

export const getSectionStatusHistory = (payload) =>
  api.get(`${baseApiURL}/sectionstatushistory`, { params: payload });
